import React from "react";
import { Redirect } from "react-router-dom";
import { adminAuthProtectedRoutes } from "./AdminRoutes";

import AdminLogin from "../pages/Admin/Login/Login";
import Login from "../pages/User/Login/Login";
import ForgotPassword from "../pages/User/ForgotPassword/ForgotPassword";

import Dashboard from "../pages/User/Dashboard/Dashboard";
import ChangePassword from "../pages/User/Profile/ChangePassword";
import Logout from "../pages/User/Logout/Logout";
import ResetPin from "../pages/User/ResetPIN/ResetPin";
import MyProfile from "../pages/User/Profile/MyProfile";
import UserListTreeView from "../pages/User/ManageUser/UserListTreeView";

import NewInvestmentRequest from "../pages/User/InvestmentModule/NewInvestmentRequest";
import InvestmentRequestHistory from "../pages/User/InvestmentModule/InvestmentRequestHistory";
import IncomeSummary from "../pages/User/IncomeReport/IncomeSummary";
import InvestmentHistory from "../pages/User/InvestmentModule/InvestmentHistory";
import NewWithdrawalRequest from "../pages/User/WithdrawalModule/NewWithdrawalRequest";
import WithdrawalHistory from "../pages/User/WithdrawalModule/WithdrawalHistory";
import UserListSso from "../pages/Sso/UserListSso";
import UserListTreeViewSso from "../pages/User/ManageUser/UserListTreeViewSso";
import TeamInvestmentHistory from "../pages/User/InvestmentModule/TeamInvestmentHistory";
import CommissionHistory from "../pages/User/IncomeReport/CommissionHistory";
import AddMoney from "../pages/User/AddMoney/AddMoney";
import WalletStatement from "../pages/User/Wallet/WalletStatement";
import CommissionSummary from "../pages/User/Wallet/CommissionSummary";
import FundRequestHistory from "../pages/User/Wallet/FundRequestHistory";
import WalletTransferHistory from "../pages/User/Wallet/WalletTransferHistory";
import WalletReceivedHistory from "../pages/User/Wallet/WalletReceivedHistory";
import InsuranceDekho from "../pages/User/Services/Insurance/InsuranceDekho";
import UtiitslPANCard from "../pages/User/Services/UtiitslPANCard/UtiitslPANCard";
import NsdlPANCard from "../pages/User/Services/NsdlPANCard/NsdlPANCard";
import AddUser from "../pages/User/DbModule/AddUser";
import UserList from "../pages/User/DbModule/UserList";
import Recharge from "../pages/User/Services/Recharge/Recharge";
import NsdlPANCardReport from "../pages/User/Services/NsdlPANCard/NsdlPANCardReport";
import DeveloperAPI from "../pages/User/DeveloperAPI/DeveloperAPI";
import AddPackage from "../pages/User/CommercialMaster/AddPackage";
import PackageList from "../pages/User/CommercialMaster/PackageList";
import SetCommercial from "../pages/User/CommercialMaster/SetCommercial";
import NsdlReceipt from "../pages/User/Services/NsdlPANCard/NsdlReceipt";
import NotFound from "../pages/NotFound";
import Signup from "../pages/User/Signup/Signup";
import RechargeReport from "../pages/User/Services/Recharge/RechargeReport";
import MyCommission from "../pages/User/Profile/MyCommission";
import BillPayment from "../pages/User/Services/BillPayment/BillPayment";
import BillPaymentReport from "../pages/User/Services/BillPayment/BillPaymentReport";
import DigitCommissionClaim from "../pages/User/Services/DigitCommissionClaim/DigitCommissionClaim";
import UtiitslPanCardV2 from "../pages/User/Services/UTI_v2/UtiitslPANCardV2";
import FindPanNumber from "../pages/User/Services/UTI_v2/FindPanNumber";
import PanFindReport from "../pages/User/Services/UTI_v2/PanFindReport";
import UtiitslPANCardV2Report from "../pages/User/Services/UTI_v2/UtiitslPANCardV2Report";
import UtiV2UploadPending from "../pages/User/Services/UTI_v2/UploadPending";
import UtiV2ObjectionList from "../pages/User/Services/UTI_v2/ObjectionList";
import UtiV2ObjectionDocUpload from "../pages/User/Services/UTI_v2/ObjectionDocUpload";
import PANForm from "../pages/User/Services/UTI_v2/PANForm";
import AEPS from "../pages/User/Services/AEPS/AEPS";
import UAEPS from "../pages/User/Services/AEPS/UAeps";
import AepsReport from "../pages/User/Services/AEPS/AepsReport";
import ThankYou from "../pages/User/ThankYou";
import Settlement from "../pages/User/Services/Settlement/Settlement";
import AddBankAccount from "../pages/User/Services/Settlement/AddBankAccount";
import ManageBankAccount from "../pages/User/Services/Settlement/ManageBankAccount";
import MicroAtm from "../pages/User/Services/MicroATM/MicroAtm";
import MicroAtmReport from "../pages/User/Services/MicroATM/MicroAtmReport";
import SettlementReport from "../pages/User/Services/Settlement/SettlementReport";
import UtiV2CrForm from "../pages/User/Services/UTI_v2/CR/CRForm";
import UtiV2CrUploadPending from "../pages/User/Services/UTI_v2/CR/CrUploadPending";
import UtiV2CrObjectionList from "../pages/User/Services/UTI_v2/CR/CrObjectionList";
import UtiV2CrObjectionDocUpload from "../pages/User/Services/UTI_v2/CR/CrObjectionDocUpload";
import SsoLogin from "../pages/User/Login/SsoLogin";

const authProtectedRoutes = [
  { path: "/user/dashboard", component: Dashboard },
  { path: "/user/change_password", component: ChangePassword },
  { path: "/user/reset_pin", component: ResetPin },
  { path: "/user/my_profile", component: MyProfile },
  { path: "/user/my_commission", component: MyCommission },
  { path: "/user/add_user", component: AddUser },
  { path: "/user/user_list_tree_view", component: UserListTreeView },
  { path: "/user/new_investment_request", component: NewInvestmentRequest },
  {
    path: "/user/investment_request_history",
    component: InvestmentRequestHistory,
  },
  {
    path: "/user/investment_history",
    component: InvestmentHistory,
  },
  {
    path: "/user/team_investment_history",
    component: TeamInvestmentHistory,
  },
  {
    path: "/user/income_summary",
    component: IncomeSummary,
  },
  {
    path: "/user/commission_history",
    component: CommissionHistory,
  },
  {
    path: "/user/new_withdrawal_request",
    component: NewWithdrawalRequest,
  },
  {
    path: "/user/withdrawal_history",
    component: WithdrawalHistory,
  },
  { path: "/user/logout", component: Logout },
  { path: "/sso/user_list", component: UserListSso },
  { path: "/sso/user_list_tree_view", component: UserListTreeViewSso },
  { path: "/user/add_money", component: AddMoney },
  { path: "/user/wallet_statement", component: WalletStatement },
  { path: "/user/commission_summary", component: CommissionSummary },
  { path: "/user/fund_request_history", component: FundRequestHistory },
  { path: "/user/wallet_transfer_history", component: WalletTransferHistory },
  { path: "/user/wallet_received_history", component: WalletReceivedHistory },
  { path: "/user/insurance", component: InsuranceDekho },
  { path: "/user/utiitsl_pancard", component: UtiitslPANCard },
  { path: "/user/nsdl_pancard", component: NsdlPANCard },
  { path: "/user/add_user", component: AddUser },
  { path: "/user/user_list", component: UserList },
  { path: "/user/recharge/:type", component: Recharge },
  { path: "/user/bill_payment/:category", component: BillPayment },
  { path: "/user/bill_payment_report", component: BillPaymentReport },
  { path: "/user/recharge_report", component: RechargeReport },
  { path: "/user/nsdl_pancard_report", component: NsdlPANCardReport },
  { path: "/user/developer_api", component: DeveloperAPI },
  { path: "/user/add_package", component: AddPackage },
  { path: "/user/package_list", component: PackageList },
  { path: "/user/set_commercial", component: SetCommercial },
  { path: "/user/digit_commission_claim", component: DigitCommissionClaim },
  { path: "/user/utiitsl_pancard_v2", component: UtiitslPanCardV2 },
  { path: "/user/utiitsl_pancard_v2/cr_form", component: UtiV2CrForm },
  {
    path: "/user/utiitsl_pancard_v2/upload_pending",
    component: UtiV2UploadPending,
  },
  {
    path: "/user/utiitsl_pancard_v2/cr_upload_pending",
    component: UtiV2CrUploadPending,
  },
  {
    path: "/user/utiitsl_pancard_v2/objection_list",
    component: UtiV2ObjectionList,
  },
  {
    path: "/user/utiitsl_pancard_v2/cr_objection_list",
    component: UtiV2CrObjectionList,
  },
  {
    path: "/user/utiitsl_pancard_v2/objection_doc_upload",
    component: UtiV2ObjectionDocUpload,
  },
  {
    path: "/user/utiitsl_pancard_v2/cr_objection_doc_upload",
    component: UtiV2CrObjectionDocUpload,
  },
  {
    path: "/user/utiitsl_pancard_v2/report",
    component: UtiitslPANCardV2Report,
  },
  { path: "/user/find_pan_number", component: FindPanNumber },
  { path: "/user/pan_find_report", component: PanFindReport },
  { path: "/user/aeps", component: AEPS },
  { path: "/user/uaeps", component: UAEPS },
  { path: "/user/aeps_report", component: AepsReport },
  { path: "/user/settlement", component: Settlement },
  { path: "/user/settlement_report", component: SettlementReport },
  { path: "/user/add_bank_account", component: AddBankAccount },
  { path: "/user/manage_bank_account", component: ManageBankAccount },
  { path: "/user/fund_request_history", component: FundRequestHistory },
  { path: "/user/micro_atm", component: MicroAtm },
  { path: "/user/micro_atm_report", component: MicroAtmReport },
];

const publicRoutes = [
  // {
  //   path: "/",
  //   exact: true,
  //   component: () => <Redirect to="/login" />,
  // },
  // {
  //   path: "/",
  //   exact: true,
  //   component: () => <Redirect to="/admin_login" />,
  // },
  { path: "/sso_login", component: SsoLogin },
  { path: "/login", component: Login },
  { path: "/signup", component: Signup },
  { path: "/forgot_password", component: ForgotPassword },
  { path: "/admin_login", component: AdminLogin },
  { path: "/user/thank_you", component: ThankYou },
  { path: "/user/nsdl_receipt", component: NsdlReceipt },
  { path: "/user/pan_form/:orderId", component: PANForm },
];

export { adminAuthProtectedRoutes, authProtectedRoutes, publicRoutes };
